import type { AuditSection } from "@ravnar/api-contract";

/**
 * Vocabulary of the settings pages. Roles and the roles each member may give, access levels, audit log sections and
 * company identity choices come from the API contract, which the API validates requests with; the labels only these
 * pages show live here.
 */
export {
	ACCESS_LEVEL_LABELS,
	ACCESS_LEVELS,
	assignableRoles,
	AUDIT_SECTIONS,
	CURRENCIES,
	IDENTITY_FIELD_LABELS,
	INDUSTRY_IDS,
	INDUSTRY_LABELS,
	MEMBER_ROLE_LABELS,
	MEMBER_ROLES,
} from "@ravnar/api-contract";

/** What the Audit log page calls each section of the log. */
export const AUDIT_SECTION_LABELS: Readonly<Record<AuditSection, string>> = {
	access: "Access",
	organization: "Organization",
	people: "People",
	directory: "Directory",
	documents: "Documents",
	finance: "Finance",
	agents: "Agents",
};

/**
 * Dot colour per section, reusing the section hues rather than tokens of their own: People and Finance in their own
 * sections' hues, Documents in Intake's blue as the New menu's Upload documents, Agents in the purple an agent's chip
 * wears, Access in the brand's gold and Organization, the company's own settings, in grey. Full class names, never
 * built from strings, so Tailwind can find them.
 */
export const AUDIT_SECTION_DOT_CLASS: Readonly<Record<AuditSection, string>> = {
	access: "bg-gold",
	organization: "bg-ink-4",
	people: "bg-people",
	directory: "bg-equity",
	documents: "bg-ops",
	finance: "bg-finance",
	agents: "bg-tax",
};

/** Identity fields that invoices and contracts cannot do without. */
export const REQUIRED_IDENTITY_FIELDS = [
	"companyName",
	"legalName",
	"streetAddress",
	"city",
	"zipCode",
	"country",
] as const;
